"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAreaWithGrids = exports.isGeoGrid = exports.isItemGeneratedGridCell = exports.isItemGeneratedGeoObject = exports.itemGeneratedGeoObjectCellSizeKey = exports.itemGeneratedGeoObjectKey = exports.makeIPathToIGeofence = exports.isValidGeoObject = exports.isIPlace = exports.isIGeofence = exports.isIPath = exports.isLocatableByBounds = exports.isLocatableByPosition = exports.hasBounds = exports.isBounds = exports.isGPS_Data = exports.isPositionArray = exports.isTurfPosition = exports.isPosition = exports.isValidLongitude = exports.isValidLatitude = void 0;
const Utils_1 = require("./Utils");
const validationCore_1 = require("./Validation/validationCore");
var Heading;
(function (Heading) {
    Heading[Heading["N"] = 0] = "N";
    Heading[Heading["NNE"] = 1] = "NNE";
    Heading[Heading["NE"] = 2] = "NE";
    Heading[Heading["ENE"] = 3] = "ENE";
    Heading[Heading["E"] = 4] = "E";
    Heading[Heading["ESE"] = 5] = "ESE";
    Heading[Heading["SE"] = 6] = "SE";
    Heading[Heading["SSE"] = 7] = "SSE";
    Heading[Heading["S"] = 8] = "S";
    Heading[Heading["SSW"] = 9] = "SSW";
    Heading[Heading["SW"] = 10] = "SW";
    Heading[Heading["WSW"] = 11] = "WSW";
    Heading[Heading["W"] = 12] = "W";
    Heading[Heading["WNW"] = 13] = "WNW";
    Heading[Heading["NW"] = 14] = "NW";
    Heading[Heading["NNW"] = 15] = "NNW";
})(Heading || (Heading = {}));
const isValidLatitude = (lat) => (0, validationCore_1.isNonNaNNumber)(lat) && Math.abs(lat) <= 90;
exports.isValidLatitude = isValidLatitude;
const isValidLongitude = (lng) => (0, validationCore_1.isNonNaNNumber)(lng) && Math.abs(lng) <= 180;
exports.isValidLongitude = isValidLongitude;
const isPosition = (possiblePosition) => {
    return !!possiblePosition && (0, exports.isValidLatitude)(possiblePosition.lat) && (0, exports.isValidLongitude)(possiblePosition.lng);
};
exports.isPosition = isPosition;
const isTurfPosition = (pos) => !!pos && pos instanceof Array && (0, exports.isValidLongitude)(pos.at(0)) && (0, exports.isValidLongitude)(pos.at(1));
exports.isTurfPosition = isTurfPosition;
const isPositionArray = (possible) => {
    return possible instanceof Array && possible.every(exports.isPosition);
};
exports.isPositionArray = isPositionArray;
/** IOTV Device Specific GPS field spec */
const isGPS_Data = (possiblePosition) => (0, validationCore_1.isNonNaNNumber)(possiblePosition.DOP) && (0, validationCore_1.isNonNaNNumber)(possiblePosition.age) && (0, validationCore_1.isNonNaNNumber)(possiblePosition.heading) && (0, exports.isPosition)(possiblePosition);
exports.isGPS_Data = isGPS_Data;
const isBounds = (ob) => {
    const { sw, ne } = (ob ?? {});
    return [sw, ne].every(exports.isPosition);
};
exports.isBounds = isBounds;
const hasBounds = (ob) => !!ob && (0, exports.isBounds)(ob.bbox);
exports.hasBounds = hasBounds;
const isLocatableByPosition = (ob) => {
    return ob && (0, exports.isPosition)(ob.location);
};
exports.isLocatableByPosition = isLocatableByPosition;
const isLocatableByBounds = (ob) => {
    return ob && ob.points?.length > 2 && ob.points?.every(exports.isPosition);
};
exports.isLocatableByBounds = isLocatableByBounds;
/** currently this will return true for polygons, as it is possible that someone may want to describe a closing path */
const isIPath = (item) => item && item.points instanceof Array && item.points.length > 1 && item.points.every((point) => (0, exports.isPosition)(point));
exports.isIPath = isIPath;
/** returns true if item has points which form at least a triangle and where first and last points are the same */
const isIGeofence = (item) => item &&
    item.points instanceof Array &&
    item.points.length > 2 &&
    item.points.every((point) => (0, exports.isPosition)(point)) &&
    /** 2024 06 possible data breaking addition. One of Turf or Polygons requires the first and last points to match */
    (0, Utils_1.objectsMatch)(item.points[0], item.points[item.points.length - 1]);
exports.isIGeofence = isIGeofence;
const isIPlace = (item) => item && (0, exports.isPosition)(item.location) && !(0, exports.isIPath)(item);
exports.isIPlace = isIPlace;
const isValidGeoObject = (item) => item && ((0, exports.isIGeofence)(item) || (0, exports.isIPath)(item) || (0, exports.isIPlace)(item) || (0, exports.isPosition)(item.points?.at(0)));
exports.isValidGeoObject = isValidGeoObject;
/** closes unclosed points where x.points is and array of Positions */
const makeIPathToIGeofence = (item) => {
    if ((0, exports.isIPath)(item)) {
        if (!(0, Utils_1.objectsMatch)(item.points[0], item.points[item.points.length - 1])) {
            item.points.push(item.points[0]);
        }
        return item;
    }
    else
        return null;
};
exports.makeIPathToIGeofence = makeIPathToIGeofence;
exports.itemGeneratedGeoObjectKey = 'generatedFrom';
exports.itemGeneratedGeoObjectCellSizeKey = 'cellSizeMtrs';
const isItemGeneratedGeoObject = (x) => (0, exports.isValidGeoObject)(x) &&
    typeof x.metadata?.[exports.itemGeneratedGeoObjectKey] === 'string' &&
    typeof x.metadata?.[exports.itemGeneratedGeoObjectCellSizeKey] === 'string';
exports.isItemGeneratedGeoObject = isItemGeneratedGeoObject;
const isItemGeneratedGridCell = (x) => (0, exports.isItemGeneratedGeoObject)(x) && (0, exports.isIGeofence)(x);
exports.isItemGeneratedGridCell = isItemGeneratedGridCell;
const isGeoGrid = (x) => !!x && x.cells?.every((cell) => (0, exports.isItemGeneratedGridCell)(cell));
exports.isGeoGrid = isGeoGrid;
const isAreaWithGrids = (x) => {
    return ((0, exports.isIGeofence)(x) && !!x.metadata?.grids && Object.values(x.metadata?.grids).every((grid) => grid.cells instanceof Array));
};
exports.isAreaWithGrids = isAreaWithGrids;
